export const cancelledAccountMessage = 'Your membership is no longer active but you can still buy credits on demand!';